export const global_shops = [
  {
    name: 'Vietnam',
    country: 'vn',
    code: 'vn',
    lang: 'vi',
    currency: '₫',
    flag: 'https://static.atosa.asia/logo/vietnam.png',
    is_floor: true,
    seller_api: 'banhang.shopee.vn',
    account_api: 'accounts.shopee.vn',
    buyer_api: 'shopee.vn',
    timezone: 'Asia/Ho_Chi_Minh',
    fff_config: {
      lang: 'vi',
      country: 'vn'
    }
  },
  {
    name: 'Indonesia',
    country: 'id',
    code: 'id',
    lang: 'en',
    currency: 'Rp',
    flag: 'https://static.atosa.asia/logo/indonesia.png',
    is_floor: false,
    seller_api: 'seller.shopee.co.id',
    account_api: 'accounts.shopee.co.id',
    buyer_api: 'shopee.co.id',
    timezone: 'Asia/Jakarta',
    fff_config: {
      lang: 'id',
      country: 'id'
    }
  },
  {
    name: 'Malaysia',
    country: 'my',
    code: 'my',
    lang: 'en',
    currency: 'RM',
    flag: 'https://static.atosa.asia/logo/malaysia.png',
    is_floor: false,
    seller_api: 'seller.shopee.com.my',
    account_api: 'accounts.shopee.com.my',
    buyer_api: 'shopee.com.my',
    timezone: 'Asia/Kuala_Lumpur',
    fff_config: {
      lang: 'ms',
      country: 'my'
    }
  },
  {
    name: 'Philippines',
    country: 'ph',
    code: 'ph',
    lang: 'en',
    currency: '₱',
    flag: 'https://static.atosa.asia/logo/philippines.png',
    is_floor: false,
    seller_api: 'seller.shopee.ph',
    account_api: 'accounts.shopee.ph',
    buyer_api: 'shopee.ph',
    timezone: 'Asia/Manila',
    fff_config: {
      lang: 'tl',
      country: 'ph'
    }
  },
  {
    name: 'Singapore',
    country: 'sg',
    code: 'sg',
    lang: 'en',
    currency: '$',
    flag: 'https://static.atosa.asia/logo/singapore.png',
    is_floor: false,
    seller_api: 'seller.shopee.sg',
    account_api: 'accounts.shopee.sg',
    buyer_api: 'shopee.sg',
    timezone: 'Asia/Singapore',
    fff_config: {
      lang: 'en',
      country: 'sg'
    }
  },
  {
    name: 'Thailand',
    country: 'th',
    code: 'th',
    lang: 'en',
    currency: '฿',
    flag: 'https://static.atosa.asia/logo/thailand.png',
    is_floor: false,
    seller_api: 'seller.shopee.co.th',
    account_api: 'accounts.shopee.co.th',
    buyer_api: 'shopee.co.th',
    timezone: 'Asia/Bangkok',
    fff_config: {
      lang: 'th',
      country: 'th'
    }
  },
]



// WEBPACK FOOTER //
// ./src/addon/global_config.js